import $http from "@/api/index";
import { getToken } from "../helpers/auth";
/**
 * 获取模板分页数据
 * @param {*} pagination 分页参数
 * @param {*} keyword 关键字搜索
 * @param {*} category 分组
 * @param {*} userId 用户Id
 */
export function GetSchemeInfoPageList(pagination, keyword, category, userId) {
  let getUrl = {
    method: "GET",
    url: "WFScheme/GetSchemeInfoPageList",
    requestType: 1
  };
  let para = {
    pagination: pagination,
    keyword: keyword,
    category: category,
    userId: userId
  };
  return $http(getUrl, para);
}

/**
 * 获取自定义流程模板列表
 */
export function GetCustmerSchemeInfoList() {
  let getUrl = {
    method: "GET",
    url: "WFScheme/GetCustmerSchemeInfoList",
    requestType: 1
  };
  let para = {};
  return $http(getUrl, para);
}

/**
 * 获取模板数据
 * @param {*} pagination 分页参数
 * @param {*} schemeInfoId 模板ID
 */
export function GetSchemePageList(pagination, schemeInfoId) {
  let getUrl = {
    method: "GET",
    url: "WFScheme/GetSchemePageList",
    requestType: 1
  };
  let para = {
    pagination: pagination,
    schemeInfoId: schemeInfoId
  };
  return $http(getUrl, para);
}
/**
 * 获取设计表单数据
 * @param {*} keyValue 主键
 */
export function GetSchemeData(schemeCode) {
  let getUrl = {
    method: "GET",
    url: "WFScheme/GetFormData",
    requestType: 1
  };
  let para = {
    schemeCode: schemeCode
  };
  return $http(getUrl, para);
}
/**
 * 获取自定义表单模板数据
 * @param {*} schemeId 主键
 */
export function GetScheme(schemeId) {
  let getUrl = {
    method: "GET",
    url: "WFScheme/GetScheme",
    requestType: 1
  };
  let para = {
    schemeId: schemeId
  };
  return $http(getUrl, para);
}
/**
 * 保存流程模板
 * @param {*} keyValue 主键
 * @param {*} schemeInfo 表单设计模板信息
 * @param {*} shcemeAuthorize 模板权限信息
 * @param {*} scheme 模板内容
 * @param {*} type 类型1.正式2.草稿
 */
export function SaveForm(keyValue, schemeInfo, shcemeAuthorize, scheme, type) {
  let user = getToken();
  let getUrl = {
    method: "POST",
    url: `WFScheme/SaveForm?keyValue=${keyValue}&schemeInfo=${schemeInfo}&shcemeAuthorize=${shcemeAuthorize}&scheme=${scheme}&type=${type}&currentUser=${JSON.stringify(
      user
    )}`,
    requestType: 1
  };
  // let para = {
  // keyValue,
  // schemeInfo,
  // shcemeAuthorize,
  // scheme,
  // type,
  // currentUser: user
  // };
  return $http(getUrl, {});
}

/**
 * 删除模板数据
 * @param {*} keyValue 主键
 */
export function DeleteForm(keyValue) {
  let getUrl = {
    method: "POST",
    url: `WFScheme/DeleteForm?keyValue=${keyValue}`,
    requestType: 1
  };
  return $http(getUrl, {});
}

/**
 * 更新表单模板版本
 * @param {*} schemeInfoId
 * @param {*} schemeId
 */
export function UpdateScheme(schemeInfoId, schemeId) {
  let getUrl = {
    method: "POST",
    url: `WFScheme/UpdateScheme`,
    requestType: 1
  };
  let para = {
    schemeInfoId: schemeInfoId,
    schemeId: schemeId
  };
  return $http(getUrl, para);
}

/**
 * 启用/停用表单
 * @param {*} keyValue 主键
 * @param {*} state 状态1启用0禁用
 */
export function UpDateSate(keyValue, state) {
  let getUrl = {
    method: "POST",
    url: `WFScheme/UpDateSate?keyValue=${keyValue}&state=${state}`,
    requestType: 1
  };
  let para = {};
  return $http(getUrl, para);
}
